
<!-- pre-loader -->
<header class="header">
	<div class="topbar">
		<div class="topbar-inner">
			<div class="topbar-left">
				<div
					class="topbar-socials">
					<a href="https://www.facebook.com/GAMVintoOficial" target="_blank" ><i class="fa-brands fa-facebook"></i></a>
					<a href="https://www.youtube.com/@gobiernoautonomomunicipald2078" target="_blank" ><i class="fa-brands fa-youtube"></i></a>
					<a href="https://instagram.com/gamvintobo?igshid=MzRlODBiNWFlZA==" target="_blank" ><i class="fa-brands fa-instagram"></i></a>
					<a href="https://www.tiktok.com/@alcaldiadevinto?is_from_webapp=1&sender_device=pc" target="_blank" ><i class="fa-brands fa-tiktok"></i></a>
				</div><!--topbar-socials-->
				<div class="topbar-info">
					<ul>
						<li>
							<div class="topbar-icon">
								<i class="fa-solid fa-envelope"></i>
							</div><!-- topbar-icon -->
							<div class="topbar-text">
								<a href="mailto:needhelp@company.com">soporte@gamvinto.gob.bo</a>
							</div><!-- topbar-text -->
						</li><!-- li -->
						<li>
							<div class="topbar-icon">
								<i class="fa-solid fa-clock"></i>
							</div><!-- topbar-icon -->
							<div class="topbar-text">
								<span>Atendendemos Horas: Lunes - Viernes 8:00am a 12:00pm  – 14:00pm a 18:00pm</span>
							</div><!-- topbar-text -->
						</li><!-- li -->

						<li>
							<button class="btn btn-sm btn-primary" [routerLink]="'/website/contacto'">Contacto</button>
						</li>
					</ul><!-- ul -->
				</div><!--topbar-info-->
			</div><!-- topbar-left -->
			<div class="topbar-right">
				<ul>
					<li><a target="_blank" href="https://gamvinto.gob.bo/webmail">Correo Institucional</a></li>
					<li><a [routerLink]="'/auth/sign-in'">Intranet</a></li>
				</ul><!-- ul -->
			</div><!--topbar-right-->
		</div><!-- topbar-inner -->
	</div><!--topbar-->
	<div class="main-menu sticky-header">
		<div class="main-menu-inner">
			<div class="main-menu-left">
				<div class="main-menu-logo" style="padding: 5px !important;">
					<a [routerLink]="'/website'"><img src="assets/assets-template/image/logo5.png"  alt="img-145" style="width: 13rem;"></a>
				</div><!--main-menu-logo-->
				<div class="navigation">
					<ul class="main-menu-list list-unstyled">
						<li class="has-dropdown" *ngFor="let menu of menusFinal">
							<a>{{ menu.categoria.nombre }}</a>
							<ul class="list-unstyled">
								<li>
									<a 
										*ngFor="let sub_categoria of menu.subCategorias"
										href="#" 
										[routerLink]=" menu.categoria.flag === 0 
										? ( sub_categoria?.estatico === 1 ? './website/ejecutivos/'+sub_categoria?.tipo :'./website/pagina/'+menu.categoria.dir+'/'+ sub_categoria.pagina_id) 
										: './website/categoria/'+menu.categoria.dir+'/'+ sub_categoria.dir"
									>{{sub_categoria.nombre}}</a></li>
							</ul>
						</li>
						<!-- <li class="has-dropdown">
							<a href="#">Institucional</a>
							<ul class="list-unstyled">
								<li><a href="#" [routerLink]="'./website/pagina-detalle/1/1'">Estructura Orgánica</a></li>
								<li><a href="#">Misión & Visión</a></li>
								<li><a href="#">Concejales</a></li>
								<li><a href="#">Historia del Municipio</a></li>

							</ul>
						</li> -->
						<!-- <li class="has-dropdown">
							<a href="#">Transparencia</a>
							<ul class="list-unstyled">
								<li><a href="#">Rención pública 2023</a></li>

								<li><a href="#">Documentación</a>
									<ul class="list-unstyled">
										<li><a href="#">Documentación</a></li>
									</ul>
								</li>

							</ul>
						</li> -->

						<!-- <li class="has-dropdown">
							<a href="#">Gaceta Municipal</a>
							<ul class="list-unstyled">
								<li><a href="#">POA</a></li>
								<li><a href="#">Reglamentos</a></li>
							</ul>
						</li> -->
						<!-- <li class="has-dropdown">
							<a href="#">Trámites y Servicios</a>
							<ul class="list-unstyled">
								<li><a href="#">Trámites</a></li>
								<li><a href="#">Servicios</a></li>
							</ul>
						</li> -->
						<!-- <li class="has-dropdown">
							<a href="#">Noticias</a>
							<ul class="list-unstyled">
								<li><a href="#">Noticias del Municipio</a></li>
								<li><a href="#">Noticias Actuales</a></li>
							</ul>
						</li> -->
						<!-- <li><a href="#">Proyectos</a>
						</li> -->
						<!-- <li><a href="#">Contactos</a>
						</li> -->
					</ul><!-- main-menu-list -->
				</div><!--navigation-->
			</div><!--main-menu-left-->
			<div class="main-menu-right">
				<div class="mobile-menu-button mobile-nav-toggler" onclick="listarMenuAux2()">
					<span></span>
					<span></span>
					<span></span>
				</div>
				<!-- <div class="search-box"> -->
					<!-- <a href="#" class="search-toggler">
						<i class="flaticon-search-interface-symbol"></i>
					</a> -->
					<!-- search-toggler -->
				<!-- </div> -->
				<!-- search-box -->
				<div style="padding-right: 30px;" class="main-menu-right-button">
					<a href="#"><img src="assets/assets-template/image/escudo.png" alt="img-145" style="height: 5rem;"></a>
				</div>
			</div><!--main-menu-right-->
		</div><!--main-menu-inner-->
	</div><!--main-menu-->
</header><!--header-->
<div class="page-wrapper">
	<router-outlet></router-outlet>
</div>
<!-- <section class="footer">
	<div class="footer-inner">
		<div class="container">
			<div class="row">
				<div class="col-lg-3">
					<div class="footer-widget-logo">
						<a href="index.html"><img src="assets/assets-template/image/logo2.png" class="" width="180" alt="img-25"></a>
					</div>
					<div class="footer-widget-text">
						<p>Gobierno Autónomo Mnuicipal de Vinto</p>
					</div>
					<div style="font-size: larger;" class="footer-widget-socials">
						<a href="#" class="footer-widget-socials-href"><i  class="fa-brands fa-twitter"></i></a>
						<a href="#" class="footer-widget-socials-href"><i class="fa-brands fa-facebook"></i></a>
						<a href="#" class="footer-widget-socials-href"><i class="fa-brands fa-pinterest-p"></i></a>
						<a href="#" class="footer-widget-socials-href"><i class="fa-brands fa-instagram"></i></a>
					</div>
				</div>

				<div class="col-lg-4">
					<div class="footer-widget">
						<iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGAMVintoOficial%2F%3Flocale%3Des_LA&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1013015820121371" width="400" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
					</div>
				</div>
				<div class="col-lg-5">
					<div class="footer-widget">
						<div class="footer-widget-contact">
							<h4 class="footer-widget-title">Contactenos</h4>
							<p>Cochabamba,<br>Vinto</p>
						</div>
						<div class="footer-widget-contact-list">
							<i class="fa-solid fa-envelope"></i>
							<div class="footer-widget-contact-item">
								<a href="mailto:needhelp@company.com">soporte@gamvinto.gob.bo</a>
							</div>
						</div>
						<div class="footer-widget-contact-list">
							<i class="fa-solid fa-phone"></i>
							<div class="footer-widget-contact-item">
								<a href="tel:+92-003-68-090">+4452363</a>
							</div>
						</div>

						<div class="footer-widget-contact-list">
							<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.321540213042!2d-66.3163633250651!3d-17.396350183492338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x93e30bf1d8e53b73%3A0x40e9f67f243dc645!2sGobierno%20Autonomo%20Municipal%20de%20Vinto!5e0!3m2!1ses!2sbo!4v1689609541266!5m2!1ses!2sbo" width="400" height="500" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="bottom-footer">
		<div class="conatiner">
			<p>© Copyright 2023 Sistemas Informáricos GAMV</p>
		</div>
	</div>
</section> -->
<section class="footer" style="background-image: none !important;">
	<div class="footer-inner" style="padding-bottom: 0px;">
		<div class="container">
			<div class="row">
				<div
					class="col-12 col-md-4"
					style="display: flex; align-items: center; justify-content: center; padding: 2rem 10% 1rem 10%;"
				>
						<img src="assets/assets-template/image/escudo4.png"  alt="img-145" width="210" style="padding: 21px 0px;">
				</div>
				<!-- <div class="col-12 col-md-4">
					<div class="row" style="padding: 0 2rem 0 2rem;">
						<div class="col-md-6" style="padding: 4rem 0 4rem 0;">
							<div class="footer-widget-contact-list">
								<i class="fa-solid fa-home"></i>
								<div class="footer-widget-contact-item">
									<a href="mailto:needhelp@company.com">Gobierno Autónomo Municipal de Vinto</a>
								</div>
							</div>
							<div class="footer-widget-contact-list">
								<i class="fa-solid fa-envelope"></i>
								<div class="footer-widget-contact-item">
									<a href="mailto:needhelp@company.com">soporte@gamvinto.gob.bo</a>
								</div>
							</div>
							<div class="footer-widget-contact-list">
								<i class="fa-solid fa-clock"></i>
								<div class="footer-widget-contact-item">
									<a href="tel:+915-68497684">Atendendemos Horas: Lunes - Viernes 8.00 am - 6.00 pm 1</a>
								</div>
							</div>
							<div class="footer-widget-contact-list">
								<i class="fa-solid fa-map-marker-alt"></i>
								<div class="footer-widget-contact-item">
									<a href="tel:+915-68497684">Oficina central</a>
								</div>
							</div>
						</div>
						<div class="col-md-6" style="display: flex; align-items: center; justify-content: center; padding: 0rem 0 4rem 0;">
							<div class="row">
								<div class="col-12 text-center" style="color: white; padding-bottom: 5px;">
									Síguenos en:
								</div>
								<div class="col-12">
									<ul class="mobile-nav-social list-unstyled"  style="display: flex; align-items: center; justify-content: center; padding: auto;">
										<li><a href="#"><i class="fa-brands fa-twitter"></i></a></li>
										<li><a href="#"><i class="fa-brands fa-facebook"></i></a></li>
										<li><a href="#"><i class="fa-brands fa-pinterest-p"></i></a></li>
										<li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<div class="col-12 col-md-4" style="display: flex; align-items: center; justify-content: center; padding: 2rem 0.5rem;">
					<div>
						<div class="footer-widget-contact-list">
							<i class="fa-solid fa-home"></i>
							<div class="footer-widget-contact-item">
								<a href="mailto:needhelp@company.com">Gobierno Autónomo Municipal de Vinto</a>
							</div>
						</div>
						<div class="footer-widget-contact-list">
							<i class="fa-solid fa-envelope"></i>
							<div class="footer-widget-contact-item">
								<a href="mailto:needhelp@company.com">soporte@gamvinto.gob.bo</a>
							</div>
						</div>
						<div class="footer-widget-contact-list">
							<i class="fa-solid fa-clock"></i>
							<div class="footer-widget-contact-item">
								<a href="tel:+915-68497684">Atendendemos Horas: Lunes - Viernes 8:00am a 12:00pm  – 14:00pm a 18:00pm</a>
							</div>
						</div>
						<div class="footer-widget-contact-list">
							<i class="fa-solid fa-map-marker-alt"></i>
							<div class="footer-widget-contact-item">
								<a href="https://maps.app.goo.gl/gxiWtmnctzp8byra9" target="_blank">Oficina central</a>
							</div>
						</div>						
					</div>
				</div>
				<div class="col-12 col-md-4" style="display: flex; align-items: center; justify-content: center; padding: 2rem 0.5rem;">
					<div>
						<div class="row">
							<div class="col-12 text-center" style="color: white; padding-bottom: 5px;">
								Síguenos en:
							</div>
							<div class="col-12">
								<ul class="mobile-nav-social list-unstyled"  style="display: flex; align-items: center; justify-content: center; padding: auto;">
									<li>
                    <a href="https://www.facebook.com/GAMVintoOficial" target="_blank" ><i class="fa-brands fa-facebook"></i></a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@gobiernoautonomomunicipald2078" target="_blank" ><i class="fa-brands fa-youtube"></i></a>
                  </li>
                  <li>
                    <a href="https://instagram.com/gamvintobo?igshid=MzRlODBiNWFlZA==" target="_blank" ><i class="fa-brands fa-instagram"></i></a>
                  </li>
                  <li>
                    <a href="https://www.tiktok.com/@alcaldiadevinto?is_from_webapp=1&sender_device=pc" target="_blank" ><i class="fa-brands fa-tiktok"></i></a>
                  </li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12">
					<hr style="border: 0.1px solid white;"/>
				</div>
			</div>
		</div>
	</div>
	<div class="bottom-footer" style="background-color: #ffffff00;">
		<div class="conatiner">
			<p>© Copyright 2023 Sistemas Informáticos G.A.M.V</p>
		</div>
	</div>
</section>
<div class="mobile-nav-wrapper">
	<div class="mobile-nav-overlay mobile-nav-toggler"></div><!-- mobile-nav-overlay -->
	<div class="mobile-nav-content">
		<a href="#" class="mobile-nav-close mobile-nav-toggler">
			<span></span>
			<span></span>
		</a><!-- mobile-nav-close -->
		<div class="logo-box">
			<a href="index.html"><img src="assets/image/logo2.png" width="160" height="40" alt="26"></a>
		</div><!-- logo-box -->
		<div class="mobile-nav-container">

		</div>
		<ul class="mobile-nav-contact list-unstyled">
			<li>
				<i class="fa-solid fa-phone"></i>
				<a href="tel:+8898006802">+ 445563</a>
			</li><!-- li -->
			<li>
				<i class="fa-solid fa-envelope"></i>
				<a href="mailto:needhelp@company.com">soporte@gamvinto.gob.bo</a>
			</li><!-- li -->
			<li>
				<i class="fa-solid fa-map-marker-alt"></i>
				Cochabamba - Vinto
			</li><!-- li -->
		</ul><!-- mobile-nav-contact -->
		<ul class="mobile-nav-social list-unstyled">
			<li><a href="#"><i class="fa-brands fa-twitter"></i></a></li>
			<li><a href="https://www.facebook.com/GAMVintoOficial"><i class="fa-brands fa-facebook"></i></a></li>
			<li><a href="#"><i class="fa-brands fa-pinterest-p"></i></a></li>
			<li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
		</ul><!-- mobile-nav-social -->
	</div><!-- mobile-nav-content -->
</div><!--mobile-nav-wrapper-->
<div class="search-popup">
	<div class="search-popup-overlay search-toggler"></div><!-- search-popup-overlay -->
	<div class="search-popup-content">
		<form action="#">
			<label for="search" class="sr-only">search here</label><!-- sr-only -->
			<input type="text" id="search" placeholder="Search Here...">
			<button type="submit" aria-label="search submit" class="search-btn">
				<span><i class="flaticon-search-interface-symbol"></i></span>
			</button><!-- search-btn -->
		</form><!-- form -->
	</div><!-- search-popup-content -->
</div><!-- search-popup -->
<a href="#" class="scroll-to-top scroll-to-target" data-target="html" style="border-radius: 20px;"><i class="fa-solid fa-arrow-up"></i></a>
<!-- plugins js -->

